/**
 * Angular parity: Property Edit and Company Edit open the wizard in a **new browser tab**
 * (`window.open(..., '_blank')`), not in-app SPA navigation.
 */
export function openTransferWizardInNewTab(entityId: string, hashFragment: string): void {
  const id = String(entityId ?? "").trim()
  if (!id) return
  const path = `/transfer/${encodeURIComponent(id)}`
  const u = new URL(path, window.location.origin)
  const frag = hashFragment.replace(/^#/, "").trim()
  u.hash = frag ? `#${frag}` : ""
  window.open(u.toString(), "_blank", "noopener,noreferrer")
}
